<template>
  <div class="">
    <b-container>
      <b-row class="tabviewtable">
        <b-col>
          <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
            <div class="">
              <div class="filter_chip" v-if="filterItemsArray[0]['Date'] != ''">
                <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
                <span @click="removeChip('Date')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['Code'] != ''">
                <span>PO code: {{ filterItemsArray[0]["Code"] }}</span>
                <span @click="removeChip('Code')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['SupplierName'] != ''">
                <span>Supplier Name:
                  {{ filterItemsArray[0]["SupplierName"] }}</span>
                <span @click="removeChip('SupplierName')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['StatusName'] != ''">
                <span>Status: {{ filterItemsArray[0]["StatusName"] }}</span>
                <span @click="removeChip('StatusName')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['ApprovalStatusNames'] != ''">
                <span>Approval Status:
                  {{ filterItemsArray[0]["ApprovalStatusNames"] }}</span>
                <span @click="removeChip('ApprovalStatusNames')"><i class="pi pi-times"></i>
                </span>
              </div>
            </div>
            <div class="">
              <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                Clear all
              </button>
            </div>
          </div>
          <div v-if="windowWidth > 545">
            <b-row>
              <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
                <!-- <div>
                    <button class="btn resetallfilter me-2 rounded-pill"> All</button>
                </div> -->
                <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                  <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                    :ClearDateFilter="SearchValue" v-if="FilterLoading">
                    <template v-slot:filterslot>
                      <poGrnFilters @suppliersename="EmitSupplierName" @supplierseid="EmitSupplierId"
                        @updatedcode="Emitcode" @StatusNames="EmitStatus" @StatusIds="EmitStatusId"
                        @ApprovalStatusName="EmitAppstatus" @ApprovalStatusIds="EmitApprovalStatusIds"
                        :removechiptype="removechipvalue" :StatusFilter="StatusFilter" :resetfilter="resetfilter"
                        :itemsList="items" />
                    </template>
                  </FilterForm>
                </b-collapse>
              </b-col>
              <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty v-if="
                    items.length === 0 &&
                    !SearchValue.inputValue &&
                    !SearchValue.fromDate &&
                    !SearchValue.toDate &&
                    !hasData &&
                    !DetailsId.PIId &&
                    !DetailsId.PRId
                  " eheader="Purchase Order" econtent="Purchase Order" eimg="/src/assets/Img/icons/itemmaster.svg"
                    @createNew="IsCreate" :createline="QueryStringValue4.StroeId || IsAddButton" />
                  <Tableview v-if="
                    items.length !== 0 ||
                    SearchValue.inputValue ||
                    SearchValue.fromDate ||
                    SearchValue.toDate ||
                    hasData
                  " :value="items" :paginator="false" class="p-datatable-gridlines commonstatusclass" :rows="10"
                    :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                    :columns="headers" @row-click="RowClick" :globalFilterFields="globalFilterFields" :filters="filters"
                    :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false" :searchbox1="true"
                    @search="SearchBox" :exceldownload="true" :filterbtn="true" :statusFilterBtn="true"
                    :showColumnFilters="false">
                    <template v-slot:POAColor="{ data }">
                      <span>
                        <b style="color: red">{{ data.POACycleCount }}</b>
                      </span>
                    </template>
                    <template v-slot:statusFilterBtn>
                      <div class="filterBtnStatus d-flex align-items-center">
                        <div class="filter_chip1" :class="{
                          'selected-chip': item.id === selectedStatus,
                        }" v-for="item in filterStatus" :key="item.id" @click="selectStatus(item.id, item.name)">
                          <p>
                            <span>{{ item.name }}</span>
                          </p>
                        </div>
                      </div>
                    </template>
                    <template v-slot:exceldownload>
                      <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                        :PageName="PageName" :ExportOption="ExportOption" class="ms-2"
                        :HideAndShow="ExportOptionHide" />
                    </template>

                    <template v-slot:filter>
                      <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                        :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                        @click="visible = !visible"></i>
                    </template>

                    <template v-slot:waitingsince="{ data }">
                      <p>
                        {{
                          data.Status == "3" || data.Status == "0"
                            ? waitingtime(data.DocDateHR)
                            : "-"
                        }}
                      </p>
                    </template>

                    <template v-slot:Add v-if="!QueryStringValue4.StroeId && IsAddButton">
                      <span class="add">
                        <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')"></AddButton>
                      </span>
                    </template>

                    <template v-slot:status="{ data }" class="">
                      <RedStatus name="Draft" v-if="data.IsDraft == '1'" />
                      <OrangeStatus name="Pending" v-if="data.Status == '0' && data.IsDraft != '1'" />
                      <RedStatus name="Cancelled PO Amendment" v-if="data.Status == '5' && data.IsDraft != '1'" />
                      <RedStatus name="Cancelled PO" v-if="data.Status == '4' && data.IsDraft != '1'" />
                      <div v-if="data.Status == '4' && data.IsDraft != '1'">
                        <span for="">Reason: {{ data?.CancelReason }}</span>
                      </div>
                      <RedStatus name="Closed" v-if="data.Status == '6' && data.IsDraft != '1'" />
                      <div v-if="data.Status == '6' && data.IsDraft != '1'">
                        <span for="">Reason: {{ data?.ClosedReason }}</span>
                      </div>
                      <BlueStatus name="Converted To PO Amendment" v-if="data.Status == '1' && data.IsDraft != '1'" />
                      <GreenStatus name="Converted To GRN Completed" v-if="data.Status == '2' && data.IsDraft != '1'" />
                      <BlueStatus name="Converted To GRN Partially" v-if="data.Status == '3' && data.IsDraft != '1'" />
                    </template>

                    <template v-slot:ApprovalStatus="{ data }">
                      <div v-if="data.IsDraft == '1'">
                        <span>-</span>
                      </div>
                      <div v-else>
                        <OrangeStatus name="Pending" v-if="data.IsApproved == '0' || data.IsApproved == '2'" />
                        <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
                        <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
                      </div>
                    </template>

                    <template v-slot:action="{ data }">
                      <span>
                        <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                          @click="toggle($event, data)" />
                      </span>
                    </template>
                  </Tableview>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="
                items.length === 0 &&
                !SearchValue.inputValue &&
                !SearchValue.fromDate &&
                !SearchValue.toDate &&
                !DetailsId.PIId &&
                !DetailsId.PRId
              " eheader="Purchase Order" econtent="Purchase Order" eimg="/src/assets/Img/icons/itemmaster.svg"
                @createNew="IsCreate" :createline="QueryStringValue4.StroeId" />
              <MobileViewCardHeader v-if="
                items.length !== 0 ||
                SearchValue.inputValue ||
                SearchValue.fromDate ||
                SearchValue.toDate
              " :totalRecords="rowsCount" :state="state" @IsAdd="IsCreate" @search="SearchBox">
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <div class="d-flex align-items-center gap-1">
                          <p class="light-name">{{ item["DocNo"] }}</p>
                          <p class="light-name1" v-if="item['RefNo']">
                            / {{ item["RefNo"] }}
                          </p>
                        </div>
                        <p class="name">{{ item["SupplierName"] }}</p>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <RedStatus name="Draft" v-if="item.IsDraft == '1'" />
                          <OrangeStatus name="Pending" v-if="item.Status == '0' && item.IsDraft != '1'" />
                          <RedStatus name="Cancel To PO Amendment" v-if="item.Status == '5' && item.IsDraft != '1'" />
                          <RedStatus name="Cancelled PO" v-if="item.Status == '4' && item.IsDraft != '1'" />
                          <div v-if="item.Status == '4' && item.IsDraft != '1'">
                            <span for="">Reason: {{ item?.CancelReason }}</span>
                          </div>
                          <RedStatus name="Closed" v-if="item.Status == '6' && item.IsDraft != '1'" />
                          <div v-if="item.Status == '6' && item.IsDraft != '1'">
                            <span for="">Reason: {{ item?.ClosedReason }}</span>
                          </div>
                          <BlueStatus name="Converted To PO Amendment"
                            v-if="item.Status == '1' && item.IsDraft != '1'" />
                          <BlueStatus name="Converted To GRN Completed"
                            v-if="item.Status == '2' && item.IsDraft != '1'" />
                          <BlueStatus name="Converted To GRN Partially"
                            v-if="item.Status == '3' && item.IsDraft != '1'" />
                        </div>

                        <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                      </div>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item count :</p>
                      <p class="small-name">{{ item["ItemCount"] }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item value :</p>
                      <p class="small-name">{{ item["Amount"] }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Dialog v-model:visible="ObjPOClosePopUp.Visible" modal :header="ObjPOClosePopUp.PopUpHeaderName" :breakpoints="{
    '1980px': '55vw',
    '1440px': '60vw',
    '960px': '70vw',
    '640px': '90vw',
  }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea :name="ObjPOClosePopUp.TextAareaName" :label="ObjPOClosePopUp.TextAareaName"
              :rules="{ required: false }" :id="ObjPOClosePopUp.TextAareaName" v-model="ObjPOClosePopUp.ClosedReason" />
            <Footer class="p-3" @cancel="ObjPOClosePopUp.Visible = false" @save="SaveClosePO" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Dialog v-model:visible="ObjCancelPopUp.CancelReasonPopup" modal :header="ObjCancelPopUp.PopUpHeaderName"
    :breakpoints="{
      '1980px': '55vw',
      '1440px': '60vw',
      '960px': '70vw',
      '640px': '90vw',
    }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea :name="ObjCancelPopUp.TextAareaName" :label="ObjCancelPopUp.TextAareaName"
              :rules="{ required: false }" :id="ObjCancelPopUp.TextAareaName" v-model="ObjCancelPopUp.CancelReason" />
            <Footer class="p-3" @cancel="ObjCancelPopUp.CancelReasonPopup = false" @save="SaveCancelPO" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Menu ref="menu" id="overlay_menu" :model="itemList" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete()" @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />

  <ClosedSuccessfully :content="ModelPopupDunction.CloseModelTxt" :visible="ModelPopupDunction.CloseSuccessPop"
    @ok="Close()" />

  <CloseConfirmation :Editmodel="ModelPopupDunction.CloseConfirmPop" @yes="UpdateCloseStatus()"
    @no="ModelPopupDunction.CloseConfirmPop = false" :header="ObjPOClosePopUp.ConfirmPopupHeader"
    :content="ObjPOClosePopUp.ConfirmPopupContent" />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />

  <CancelSuccessfully :content="ModelPopupDunction.CancelModelTxt" :visible="ModelPopupDunction.Cancelpop"
    @ok="cancelclose()" />
  <RevertedSuccessfully :content="ModelPopupDunction.RevertModelTxt" :visible="ModelPopupDunction.Revertpop"
    @ok="cancelclose()" />
  <CancelConfirmation :Editmodel="ModelPopupDunction.cancelmodel" @yes="Statuschange()"
    @no="ModelPopupDunction.cancelmodel = false" :header="ObjCancelPopUp.ConfirmPopupHeader"
    :content="ObjCancelPopUp.ConfirmPopupContent" />
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  reactive,
  watch,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import service from "../../../Service/SupplierMaster";
import Table from "../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../Service/WithoutStockAffectService";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import poGrnFilters from "../../../../../modules/Inventory/components/Filters/poGrnFilters.vue";
import moment from "moment";
import FilterForm from "../../../../../components/FormComponents/FilterForm.vue";
import ExportOption from "../../../../../components/FormComponents/Export.vue";

import CloseConfirmation from "../../../../../components/FormComponents/CancelConfirmation.vue";
import ClosedSuccessfully from "../../../../../components/FormComponents/CancelSuccessfully.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import CancelConfirmation from "../../../../../components/FormComponents/CancelConfirmation.vue";
import CancelSuccessfully from "../../../../../components/FormComponents/CancelSuccessfully.vue";
import RevertedSuccessfully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import MastersService from "../../../Service/MastersService";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,

    Table,
    Tableview,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    CrystalReportPrintPopUp,
    poGrnFilters,
    FilterForm,
    ExportOption,
    ClosedSuccessfully,
    CloseConfirmation,
    Footer,
    CancelSuccessfully,
    CancelConfirmation,
    RevertedSuccessfully,
  },
  props: {
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
    IsAddButton: {
      type: Boolean,
      default: true,
    },
    QueryValue: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const dataEdit = ref();
    const routes = useRoute();
    const toast = useToast();
    let hasData = ref(false);
    let dataId = routes.query.Id ?? 0;
    let QueryStringValue: any = routes.query;
    let status = routes.query.status ?? 0;
    let columnnametype = routes.query.Type ?? "";
    const loading = ref(false);
    const CrystalReportPopup = ref(false);
    const router = useRouter();
    const generic = ref();
    let items: any = ref([]);
    let copyitems: any = ref([]);
    let loading1 = ref(false);
    let Id = ref();
    const rowsCount = ref(0);
    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    let PoId = 0;
    let IsDraft = 0;
    let DocType;
    const ColumnVisible = ref(true);
    const dropdownMenu = ref(null);
    let objectdata = ref({});
    const menu = ref();
    const ItemStockTransId = ref(0);
    const Postatus = ref("");
    let visible = ref(false);
    let StorebranchmapId = routes.query.storebranchmapid ?? 0;
    const IsPending = ref(false);
    let CancelPO = ref(false);
    let RevertPo = ref(false);
    let SelectedFilterId: any = ref(10);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 14,
      HeaderTitle: "Purchase Order",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("Purchase Order");
    let ExportOption = ref("");

    let ExportOptionHide = ref(false);
    let actionePoAmendment = ref(false);
    let actioneEdit = ref(false);

    let QueryStringValue4: any = routes.query;

    let DetailsId = ref({
      PIId: QueryStringValue4["PIId"] ?? 0,
      PRId: QueryStringValue4["PRId"] ?? 0,
    });

    watch(
      () => [props.QueryValue],
      ([newQueryValue]) => {
        debugger;
        if (newQueryValue.PIId) {
          DetailsId.value.PIId = newQueryValue.PIId;
        } else if (newQueryValue.PRId) {
          DetailsId.value.PRId = newQueryValue.PRId;
        }
      },
      { immediate: true }
    );

    if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
      ColumnVisible.value = true;
    } else {
      ColumnVisible.value = false;
    }

    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    const removechipvalue = ref(0);
    const resetfilter = ref(false);

    let filterItems = ref({
      Date: "",
      SupplierName: "",
      SupplierId: "",
      Code: "",
      StatusIds: "",
      StatusName: "",
      ApprovalStatusNames: "",
      ApprovalStatusIds: "",
    });

    let emitedfilterItems = ref({
      SupplierName: "",
      SupplierId: "",
      Code: "",
      StatusIds: "",
      StatusName: "",
      ApprovalStatusNames: "",
      ApprovalStatusIds: "",
    });

    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });

    let StatusFilter = ref({
      StatusFrom: "PO",
      Status: true,
      AprrovalStatus: true,
    });

    let ObjPOClosePopUp = ref({
      Visible: false,
      ClosedReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjPOClose = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      ClosedReason: "",
      IsApproved: 0,
      StoreId: 0,
    });

    let ObjCancelPopUp = ref({
      CancelReasonPopup: false,
      CancelReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjCancelPO = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      CancelReason: "",
      IsApproved: 0,
      Type: 0,
      StoreId: 0,
      DocNo: "",
    });

    const ModelPopupDunction = ref({
      CloseConfirmPop: false,
      CloseModelTxt: "",
      CloseSuccessPop: false,
      cancelmodel: false,
      CancelModelTxt: "",
      Cancelpop: false,

      Revertmodel: false,
      RevertModelTxt: "",
      Revertpop: false,
    });

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    ////

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    watch(
      props,
      (newValue: any) => {
        debugger;
        console.log("props Changed", newValue.FunctionRights);
        Rights.value.Create = newValue.FunctionRights.Create;
        Rights.value.Update = newValue.FunctionRights.Update;
        Rights.value.Read = newValue.FunctionRights.Read;
        Rights.value.Delete = newValue.FunctionRights.Delete;

        Object.keys(ObjOperationId.value).forEach((key) => {
          if (newValue.FunctionRights[key])
            ObjOperationId.value[key] = newValue.FunctionRights[key];
        });
      },
      { deep: true }
    );

    watch(props, (newValue) => {
      debugger;

      let dataValue: any = {};
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        dataId = dataValue.Id;
        status = dataValue.Type;

        if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
          PODetails();
        } else {
          IsShow();
        }
      }
    });

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }

      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        ExportOptionHide.value = false;
        PODetails();
      } else {
        ExportOptionHide.value = true;
        IsShow();
      }
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    const toggle = (event, data) => {
      debugger;
      ItemStockTransId.value = data.StockTransId;
      actionePoAmendment.value =
        data.IsApproved == 1 && data.Status == 0 && data.IsDraft != 1 && data.popaymentinitiatecount == 0
          ? true
          : false;

      actioneEdit.value =
        (data.Status == 0 &&
          data.IsApproved != 1 &&
          data.IsConsigneeItem == 0) ||
          data.IsDraft == 1
          ? true
          : false;
      IsPending.value =
        (data.Status == "0" || data.Status == "3") &&
          data.IsDraft != "1" &&
          data.IsApproved == "1"
          ? true
          : false;
      CancelPO.value =
        data.Status == 0 &&
          data.IsApproved == 1 &&
          (data.DocType == "4" || data.DocType == "5")
          ? true
          : false;
      RevertPo.value = data.Status == 4 && data.IsApproved == 1 ? true : false;
      objectdata = data;
      menu.value.toggle(event);
    };

    const itemList = ref([
      {
        items: [
          {
            label: "Create PO Amendment",
            icon: "pi pi-user",
            visible: actionePoAmendment,
            command: async () => {
              datapass();
            },
          },
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: actionePoAmendment,
            command: async () => {
              datapass();
            },
          },
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: actioneEdit,
            command: async () => {
              Editdata(objectdata);
            },
          },

          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: actioneEdit,
            command: async () => {
              Deletedata(objectdata);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(objectdata);
            },
          },
          {
            label: "Close",
            icon: "deleteicon pi pi-times",
            visible: IsPending,
            command: async () => {
              ClosePOOnClick(objectdata);
            },
          },
          {
            label: "Cancel PO",
            icon: "deleteicon pi pi-times",
            visible: CancelPO,
            command: async () => {
              CancelPOOnClick(objectdata);
            },
          },
          {
            label: "Revert",
            icon: "pi pi-refresh",
            visible: RevertPo,
            command: async () => {
              RevertPO(objectdata);
            },
          },
        ],
      },
    ]);

    async function datapass() {
      debugger;

      const response = await MastersService.CheckMenuRights(
        3039, // POAmendment EntityId
        rolesData.RoleId
      );

      let POARights = ref({
        Create: false,
        Update: false,
        Read: false,
        Delete: false,
      });

      let POAObjOperationId = ref({
        CreateId: 0,
        UpdateId: 0,
        ReadId: 0,
        DeleteId: 0,
      });

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          POAObjOperationId.value.CreateId = operation.OperationID;
          POARights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          POAObjOperationId.value.UpdateId = operation.OperationID;
          POARights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          POAObjOperationId.value.ReadId = operation.OperationID;
          POARights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          POAObjOperationId.value.DeleteId = operation.OperationID;
          POARights.value.Delete = operation.IsActive;
        }
      }

      console.log(response);
      let permissionResult: any = checkPermission(POARights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/POCreation",
          query: {
            formId: 1026,
            param: "POAmendment",
            doctype: 6,
            StockTransId: ItemStockTransId.value,
            StoreId: dataId,
            status: status,
            OperationId: 3039001,
            EntityId: 3039,
            storebranchmapid: StorebranchmapId,
            BranchId: routes.query.BranchId ?? 0,
            IsFlag: 1,
            IsDraft: 0,
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      DocDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      RefNo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      SupplierName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      POStatusName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t("storetabdetails.po.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.po.Status"),
        field: "POStatusName",
        fieldDisplay: "false",
        slot: "status",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        // bodyclass: "text_overflow2",
      },
      {
        header: t("storetabdetails.po.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.po.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.po.Supplier"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.po.RequestedBy"),
        field: "CreatedByName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.po.ItemCount"),
        field: "ItemCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.po.Value"),
        field: "Amount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.po.ToStore"),
        field: "ToStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },

      {
        header: t("storetabdetails.po.RefNo"),
        field: "RefNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.po.POACycle"),
        field: "POACycleCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
        slot: "POAColor",
        fieldDisplay: "false",
      },
      {
        field: "",
        fieldDisplay: "false",
        header: t("storetabdetails.po.PendingSince"),
        slot: "waitingsince",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.po.ApprovalStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "ApprovalStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: ColumnVisible.value,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));

    const IsCreate = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          name: "POCreation",
          query: {
            formId: 1020,
            doctype: "4",
            param: "PO",
            StockTransId: "0",
            StoreId: dataId,
            status: status,
            OperationId: ObjOperationId.value.CreateId,
            EntityId: ObjOperationId.value.EntityId,
            storebranchmapid: StorebranchmapId,
            BranchId: routes.query.BranchId ?? 0,
            IsZeroBill: routes.query.IsZeroBill,
            IsDraft: 1,
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsEdit(dataEdit) {
      debugger;
      router.push({
        path: "/POCreation",
        query: {
          param: "PO",
          doctype: DocType,
          formId: 1020,
          StockTransId: PoId,
          StoreId: dataId,
          status: status,
          OperationId: ObjOperationId.value.UpdateId,
          EntityId: ObjOperationId.value.EntityId,
          storebranchmapid: StorebranchmapId,
          BranchId: routes.query.BranchId ?? 0,
          IsDraft: IsDraft,
        },
      });
    }

    const filterStatus = [
      { id: 10, name: "All" },
      { id: 6, name: "Draft" },
      { id: 0, name: "Pending" },
      { id: 3, name: " Partially" },
    ];

    const selectedStatus = ref(10);
    let buttonFilter = ref({
      Id: 0,
      Name: "",
    });

    const selectStatus = (id, name) => {
      debugger;
      selectedStatus.value = id;
      buttonFilter.value.Id = id;
      buttonFilter.value.Name = name;
      SelectedFilterId.value = String(id);
      if (id != 10) {
        StatusFilter.value.Status = false;
      } else {
        StatusFilter.value.Status = true;
        SelectedFilterId.value = 10;
        filterItems.value.StatusIds = "";
      }
      IsShow();
    };

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
          PODetails();
        } else {
          IsShow();
        }
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;

        if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
          await PODetails();
        } else {
          await IsShow();
        }
      }
    );

    // Debounced search for server-side filtering
    function SearchBox(value) {
      debugger;
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = input;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        PODetails();
      } else {
        IsShow();
      }
    }, 300);

    //Get data for TableView
    async function IsShow() {
      try {
        debugger;
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = columnnametype;
        const columnValue = dataId;
        const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
        const columnValue1 = filterItems.value.SupplierId
          ? filterItems.value.SupplierId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        let columnName3 = "";
        const columnValue3 = "";
        if (SelectedFilterId.value != 10) {
          filterItems.value.StatusIds = SelectedFilterId.value;
        }

        // let Condition = "sm.HospitalId=" + usersData.OrganizationId + " and sm.BranchId=" + usersData.BranchId + " and sm.StoreBrMapId=" + StorebranchmapId + ""
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        // if(StatusFilter.value.Status){
        //Both StatusIds and ApprovalStatusIds
        if (
          filterItems.value.StatusIds != "" &&
          filterItems.value.ApprovalStatusIds != ""
        ) {
          if (
            filterItems.value.StatusIds.includes("6") &&
            filterItems.value.ApprovalStatusIds.includes("0")
          ) {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1) and (sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null)";
          } else if (filterItems.value.StatusIds.includes("6")) {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1) and(sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null)";
          } else if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              "and sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null) ";
          } else {
            Condition =
              Condition +
              "and sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN (" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        //StatusIds
        else if (filterItems.value.StatusIds != "") {
          if (filterItems.value.StatusIds.includes("6")) {
            Condition =
              Condition +
              "and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1)";
          } else {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0))";
          }
        }

        //ApprovalStatusIds
        else if (filterItems.value.ApprovalStatusIds != "") {
          if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              " and( sm.IsApproved IN(" +
              filterItems.value.ApprovalStatusIds +
              ") or sm.IsApproved is null)";
          } else {
            Condition =
              Condition +
              " and( sm.IsApproved IN(" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",

          pageSize,
          pageNum,
          "4,5",
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        items.value = response["result"].map((item) => {
          item.Amount = Number(item.Amount).toFixed(2);
          return item;
        });

        if (items.value.length !== 0) {
          hasData.value = true;
        }
        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        copyitems.value = items.value;
        console.log(items.value);
        loading.value = false;
      } catch (error) {
        alert(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        debugger;
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = 0;
        const columnName = columnnametype;
        const columnValue = dataId;
        const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
        const columnValue1 = filterItems.value.SupplierId
          ? filterItems.value.SupplierId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        // let Condition = "sm.HospitalId=" + usersData.OrganizationId + " and sm.BranchId=" + usersData.BranchId + " and sm.StoreBrMapId=" + StorebranchmapId + ""
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        //Both StatusIds and ApprovalStatusIds
        if (
          filterItems.value.StatusIds != "" &&
          filterItems.value.ApprovalStatusIds != ""
        ) {
          if (
            filterItems.value.StatusIds.includes("6") &&
            filterItems.value.ApprovalStatusIds.includes("0")
          ) {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1) and (sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null)";
          } else if (filterItems.value.StatusIds.includes("6")) {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1) and(sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null)";
          } else if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              "and sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null) ";
          } else {
            Condition =
              Condition +
              "and sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN (" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        //StatusIds
        else if (filterItems.value.StatusIds != "") {
          if (filterItems.value.StatusIds.includes("6")) {
            Condition =
              Condition +
              "and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1)";
          } else {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0))";
          }
        }

        //ApprovalStatusIds
        else if (filterItems.value.ApprovalStatusIds != "") {
          if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              " and( sm.IsApproved IN(" +
              filterItems.value.ApprovalStatusIds +
              ") or sm.IsApproved is null)";
          } else {
            Condition =
              Condition +
              " and( sm.IsApproved IN(" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",

          pageSize,
          pageNum,
          "4,5",
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        response["result"] = response["result"].map((item) => {
          item.Amount = Number(item.Amount).toFixed(2);
          item.PendingSince =
            item.Status == "3" || item.Status == "0"
              ? waitingtime(item.DocDateHR)
              : "-";

          if (item.IsApproved == "0") {
            item.ApprovalStatus = "Pending";
          } else if (item.IsApproved == "1") {
            item.ApprovalStatus = "Approved";
          } else if (item.IsApproved == "3") {
            item.ApprovalStatus = "Declined";
          } else {
            item.ApprovalStatus = "-"; // Fallback case
          }
          return item;
        });

        console.log("PO Table", response["result"]);

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });
          filteredItem["Pending Since"] = item.PendingSince;
          filteredItem["Approval Status"] = item.ApprovalStatus;
          return filteredItem;
        });

        loading.value = false;
      } catch (error) {
        alert(error);
      }
    }

    let ObjVal1 = reactive({
      arraylenght: 0,
    });

    function update() {
      debugger;
      emit("update:modelValue", ObjVal1);
    }

    async function PODetails() {
      debugger;

      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "RefId";
        const columnValue = DetailsId.value.PIId || DetailsId.value.PRId;
        const columnName1 = filterItems.value.SupplierId ? "SupplierId" : "";
        const columnValue1 = filterItems.value.SupplierId
          ? filterItems.value.SupplierId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        // let Condition = "sm.HospitalId=" + usersData.OrganizationId + " and sm.BranchId=" + usersData.BranchId + " and sm.StoreBrMapId=" + StorebranchmapId + ""
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          " and sm.BranchId=" +
          usersData.BranchId +
          " and sm.StoreBrMapId=" +
          StorebranchmapId +
          "";

        // //Both StatusIds and ApprovalStatusIds
        // if (filterItems.value.StatusIds != "" && filterItems.value.ApprovalStatusIds != "") {

        //   if (filterItems.value.StatusIds.includes('6') && filterItems.value.ApprovalStatusIds.includes('0')) {
        //     Condition = Condition + " and (sm.Status IN(" + filterItems.value.StatusIds + ") or sm.IsDraft =1) and (sm.IsApproved IN ( " + filterItems.value.ApprovalStatusIds + ")or sm.IsApproved is null)";
        //   }
        //   else if (filterItems.value.StatusIds.includes('6')) {
        //     Condition = Condition + " and (sm.Status IN(" + filterItems.value.StatusIds + ") or sm.IsDraft =1) and(sm.IsApproved IN ( " + filterItems.value.ApprovalStatusIds + ")or sm.IsApproved is null)";
        //   }
        //   else if (filterItems.value.ApprovalStatusIds.includes('0')) {
        //     Condition = Condition + "and sm.Status IN(" + filterItems.value.StatusIds + ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN ( " + filterItems.value.ApprovalStatusIds + ")or sm.IsApproved is null) ";
        //   }
        //   else {
        //     Condition = Condition + "and sm.Status IN(" + filterItems.value.StatusIds + ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN (" + filterItems.value.ApprovalStatusIds + "))";
        //   }
        // }

        // //StatusIds
        // else if (filterItems.value.StatusIds != "") {

        //   if (filterItems.value.StatusIds.includes('6')) {
        //     Condition = Condition + "and (sm.Status IN(" + filterItems.value.StatusIds + ") or sm.IsDraft =1)";
        //   }
        //   else {
        //     Condition = Condition + " and (sm.Status IN(" + filterItems.value.StatusIds + ") and (sm.isdraft is null or sm.isdraft=0))";
        //   }
        // }

        // //ApprovalStatusIds
        // else if (filterItems.value.ApprovalStatusIds != "") {
        //   if (filterItems.value.ApprovalStatusIds.includes('0')) {
        //     Condition = Condition + " and( sm.IsApproved IN(" + filterItems.value.ApprovalStatusIds + ") or sm.IsApproved is null)";
        //   }
        //   else {
        //     Condition = Condition + " and( sm.IsApproved IN(" + filterItems.value.ApprovalStatusIds + "))";
        //   }
        // }

        // if(StatusFilter.value.Status){
        //Both StatusIds and ApprovalStatusIds
        if (
          filterItems.value.StatusIds != "" &&
          filterItems.value.ApprovalStatusIds != ""
        ) {
          if (
            filterItems.value.StatusIds.includes("6") &&
            filterItems.value.ApprovalStatusIds.includes("0")
          ) {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1) and (sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null)";
          } else if (filterItems.value.StatusIds.includes("6")) {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1) and(sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null)";
          } else if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              "and sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN ( " +
              filterItems.value.ApprovalStatusIds +
              ")or sm.IsApproved is null) ";
          } else {
            Condition =
              Condition +
              "and sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0) and (sm.IsApproved IN (" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        //StatusIds
        else if (filterItems.value.StatusIds != "") {
          if (filterItems.value.StatusIds.includes("6")) {
            Condition =
              Condition +
              "and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") or sm.IsDraft =1)";
          } else {
            Condition =
              Condition +
              " and (sm.Status IN(" +
              filterItems.value.StatusIds +
              ") and (sm.isdraft is null or sm.isdraft=0))";
          }
        }

        //ApprovalStatusIds
        else if (filterItems.value.ApprovalStatusIds != "") {
          if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              " and( sm.IsApproved IN(" +
              filterItems.value.ApprovalStatusIds +
              ") or sm.IsApproved is null)";
          } else {
            Condition =
              Condition +
              " and( sm.IsApproved IN(" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",

          pageSize,
          pageNum,
          "4,5",
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        console.log(response["result"]);
        response["result"] = response["result"];
        ObjVal1.arraylenght = response["result"].length;

        update();

        items.value = response["result"];

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    //Delete Values in Table
    const IsDelete = async () => {
      try {
        const response = await commonService.DeleteStockWOTM(PoId);
        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
            PODetails();
          } else {
            IsShow();
          }
          Deletemodel.value = false;
          deletepop.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    };

    // row click for table
    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;

      router.push({
        path: "/POGRNDetail",
        query: {
          Id: event.data ? event.data.StockTransId : event.StockTransId,
          storebranchmapid: routes.query.storebranchmapid ?? 0,
          BranchId: routes.query.BranchId ?? 0,
          status: status,
        },
      });
    }

    function Editdata(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        PoId = data.StockTransId;
        IsDraft = data.IsDraft;
        DocType = data.DocType;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function Deletedata(data) {
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        PoId = data.StockTransId;
        DocType = data.DocType;
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function ClosePOOnClick(data) {
      debugger;

      ObjPOClosePopUp.value.PopUpHeaderName = t("confirmation.closepo");
      ObjPOClosePopUp.value.TextAareaName = t("confirmation.EnterReason");
      ObjPOClosePopUp.value.ClosedReason = "";

      ObjPOClosePopUp.value.Visible = true;

      ObjPOClose.value.EntityOperationId = 3044007;
      ObjPOClose.value.DeptRoleId = rolesData.DeptRoleMapId;
      ObjPOClose.value.Id = data.StockTransId;
      ObjPOClose.value.Status = "6";
      ObjPOClose.value.IsApproved = 0;
      ObjPOClose.value.CreatedBy = usersData.UserId;
      ObjPOClose.value.BranchId = data.BranchId;
      ObjPOClose.value.HospitalId = data.HospitalId;
      ObjPOClose.value.StoreId = data.StoreId;

      ObjPOClosePopUp.value.ConfirmPopupHeader = t("confirmation.confirmclose");
      ObjPOClosePopUp.value.ConfirmPopupContent = t(
        "confirmation.Doyouwanttoclose"
      );
    }

    function SaveClosePO() {
      debugger;
      if (ObjPOClosePopUp.value.ClosedReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.CloseConfirmPop = true;
      }
    }

    function SaveCancelPO() {
      debugger;
      if (ObjCancelPopUp.value.CancelReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.cancelmodel = true;
      }
    }

    async function UpdateCloseStatus() {
      debugger;
      try {
        ObjPOClose.value.ClosedReason = ObjPOClosePopUp.value.ClosedReason;

        const response = await commonService.UpdateCloseStatus(
          ObjPOClose.value
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          ModelPopupDunction.value.CloseConfirmPop = false;
          ModelPopupDunction.value.CloseModelTxt = t(
            "confirmation.poslosedsuccessfully"
          );
          ModelPopupDunction.value.CloseSuccessPop = true;
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    }

    function Close() {
      ModelPopupDunction.value.CloseSuccessPop = false;
      // if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
      //   ExportOptionHide.value = false;
      //   PODetails();
      // } else {
      //   ExportOptionHide.value = true;
      //   IsShow();
      // }
      // alert(0)
      // router.back();

      // setupHistoryManagement(router, 1);
    }

    const Ddstate = reactive({
      isDropdownVisible: false,
    });

    const toggleDropdown = () => {
      Ddstate.isDropdownVisible = !Ddstate.isDropdownVisible;
    };

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.Id;
      ParameterValues.value.BranchId = ObjData.BranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    const EmitSupplierName = (data) => {
      emitedfilterItems.value.SupplierName = data;
    };

    const EmitSupplierId = (data) => {
      emitedfilterItems.value.SupplierId = data;
    };

    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    const EmitStatus = (data) => {
      emitedfilterItems.value.StatusName = data;
    };

    const EmitStatusId = (data) => {
      emitedfilterItems.value.StatusIds = data;
    };

    const EmitAppstatus = (data) => {
      emitedfilterItems.value.ApprovalStatusNames = data;
    };

    const EmitApprovalStatusIds = (data) => {
      emitedfilterItems.value.ApprovalStatusIds = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      filterItems.value.SupplierName = emitedfilterItems.value.SupplierName;
      filterItems.value.SupplierId = emitedfilterItems.value.SupplierId;
      filterItems.value.Code = emitedfilterItems.value.Code;

      filterItems.value.StatusName = emitedfilterItems.value.StatusName;
      filterItems.value.StatusIds = emitedfilterItems.value.StatusIds;

      filterItems.value.ApprovalStatusNames =
        emitedfilterItems.value.ApprovalStatusNames;
      filterItems.value.ApprovalStatusIds =
        emitedfilterItems.value.ApprovalStatusIds;
      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.SupplierId = "";
      filterItems.value.StatusName = "";
      filterItems.value.StatusIds = "";
      filterItems.value.ApprovalStatusNames = "";
      filterItems.value.ApprovalStatusIds = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      filterItems.value.Code = "";
      resetfilter.value = resetfilter.value == true ? false : true;
      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        PODetails();
      } else {
        IsShow();
      }
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      emptyObjectList();
      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        PODetails();
      } else {
        IsShow();
      }
    }
    const emptyObjectList = () => {
      let emptyLoadingObj = {};
      for (let i = 0; i < 5; i++) {
        items.value.push({ ...emptyLoadingObj });
      }
    };

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      } else if (data == "SupplierName") {
        filterItems.value.SupplierId = "";
        removechipvalue.value = 2;
      } else if (data == "StatusName") {
        filterItems.value.StatusIds = "";
        removechipvalue.value = 3;
      } else if (data == "ApprovalStatusNames") {
        filterItems.value.ApprovalStatusIds = "";
        removechipvalue.value = 4;
      }

      filterItems.value[data] = ""; // Clear the value in the filterItems object
      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        PODetails();
      } else {
        IsShow();
      }
    };

    const waitingtime = (targetDate) => {
      const currentDate = new Date().getTime(); // Convert Date to number (timestamp)
      const targetDateTime = new Date(targetDate).getTime(); // Convert Date to number (timestamp)
      const differenceInTime = Math.abs(currentDate - targetDateTime);

      const differenceInDays = Math.floor(
        differenceInTime / (1000 * 3600 * 24)
      );
      const differenceInMonths = Math.floor(differenceInDays / 30);
      const differenceInYears = Math.floor(differenceInDays / 365);

      const years =
        differenceInYears > 0
          ? `${differenceInYears} Year${differenceInYears > 1 ? "s" : ""}`
          : "";
      const months =
        differenceInMonths % 12 > 0
          ? `${differenceInMonths % 12} Month${differenceInMonths % 12 > 1 ? "s" : ""
          }`
          : "";
      const days =
        differenceInDays % 30 > 0
          ? `${differenceInDays % 30} Day${differenceInDays % 30 > 1 ? "s" : ""
          }`
          : "";

      // If the difference is exactly 0 days, return "0 days"
      if (differenceInDays === 0) {
        return "0 Day";
      }

      return `${years} ${months} ${days}`.trim();
    };

    function cancelclose() {
      ModelPopupDunction.value.Cancelpop = false;
      ModelPopupDunction.value.Revertpop = false;
      if (DetailsId.value.PIId != 0 || DetailsId.value.PRId != 0) {
        ExportOptionHide.value = false;
        PODetails();
      } else {
        ExportOptionHide.value = true;
        IsShow();
      }
    }

    function CancelPOOnClick(data) {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.cancelpo");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.cancelreason");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPO.value.DocNo = data.DocNo;
      ObjCancelPO.value.EntityId = data.EntityId;
      ObjCancelPO.value.EntityOperationId = 3044005;
      ObjCancelPO.value.Status = "4";
      ObjCancelPO.value.IsApproved = 0;
      ObjCancelPO.value.Type = 1;

      ObjCancelPO.value.DeptRoleId = rolesData.DeptRoleMapId;
      ObjCancelPO.value.Id = data.StockTransId;
      ObjCancelPO.value.CreatedBy = usersData.UserId;
      ObjCancelPO.value.BranchId = data.BranchId;
      ObjCancelPO.value.HospitalId = data.HospitalId;
      ObjCancelPO.value.StoreId = data.StoreId;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.confirmcancel");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttocancel"
      );
    }

    function RevertPO(data) {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.revertpo");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.revertreason");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPO.value.DocNo = data.DocNo;
      ObjCancelPO.value.EntityId = data.EntityId;
      ObjCancelPO.value.EntityOperationId = 3044006;
      ObjCancelPO.value.Status = "0";
      ObjCancelPO.value.IsApproved = 0;
      ObjCancelPO.value.Type = 2;

      ObjCancelPO.value.DeptRoleId = rolesData.DeptRoleMapId;
      ObjCancelPO.value.Id = data.StockTransId;
      ObjCancelPO.value.CreatedBy = usersData.UserId;
      ObjCancelPO.value.BranchId = data.BranchId;
      ObjCancelPO.value.HospitalId = data.HospitalId;
      ObjCancelPO.value.StoreId = data.StoreId;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.conformrevert");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttorevert"
      );
    }

    const Statuschange = async () => {
      debugger;
      try {
        ObjCancelPO.value.CancelReason = ObjCancelPopUp.value.CancelReason;
        // alert('1')

        const response = await commonService.StockWOOutStatusChanged(
          ObjCancelPO.value
        );

        // const response: any = [];

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          ObjCancelPopUp.value.CancelReasonPopup = false;
          ModelPopupDunction.value.cancelmodel = false;
          if (ObjCancelPO.value.EntityOperationId == 3044005) {
            ModelPopupDunction.value.Cancelpop = true;

            ModelPopupDunction.value.CancelModelTxt = t(
              "confirmation.pocancelsuccess"
            );
          } else if (ObjCancelPO.value.EntityOperationId == 3044006) {
            ModelPopupDunction.value.RevertModelTxt = t(
              "confirmation.porevertsuccess"
            );
            ModelPopupDunction.value.Revertpop = true;
          }
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    };

    return {
      selectStatus,
      selectedStatus,
      filterStatus,
      dropdownMenu,
      toggleDropdown,
      Editdata,
      Deletedata,
      RowClick,
      Deletemodel,
      deletepop,
      Editmodel,
      datapass,
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      menu,
      itemList,
      toggle,
      dataEdit,
      rowsCount,
      state,
      ObjVal1,
      loading,
      QueryStringValue4,
      Print,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
      hidepopup,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      EmitSupplierName,
      EmitSupplierId,
      EmitStatus,
      EmitStatusId,
      EmitAppstatus,
      EmitApprovalStatusIds,
      Emitcode,
      filterItems,
      removeChip,
      removechipvalue,
      SearchBox,
      ShowRows,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      ExportOptionHide,
      windowWidth,
      visible,
      waitingtime,
      StatusFilter,
      resetfilter,
      ObjPOClosePopUp,
      SaveClosePO,
      ModelPopupDunction,
      Close,
      UpdateCloseStatus,
      hasData,
      emitedfilterItems,
      cancelclose,
      Statuschange,
      ObjCancelPopUp,
      SaveCancelPO,
      RevertPO,
      DetailsId,
    };
  },
});
</script>

<style lang="scss">
.commonstatusclass {
  .p-badge {
    font-size: 10px !important;
    /* Set your desired font size */
    font-weight: 500 !important;
    /* Set your desired font weight */
  }
}

.filterBtnStatus {
  overflow: auto !important;
}

.filter_chip1 {
  border: 1px solid #dee2e6 !important;
  display: inline-block;
  color: #495057;
  border-radius: 16px;
  padding: 6px 10px;
  margin-right: 5px;
  margin-bottom: 5px;
  width: max-content;
  text-align: center;
  font-size: 11px;
  font-weight: 500;
}

.selected-chip {
  color: #ffffff;
  background-color: #0a82ff !important;
  border: 1px solid #0a82ff;
  transition: 0.5s;
}
</style>
